import classNames from "classnames";
import React from "react";
import { IAttachment } from "../../models/chat/chatItems";
import styles from "./filePreviews.css";
import { FileThumbnail } from "./fileThumbnail";

type Props = {
  attachments: Array<IAttachment>;
  alignRight?: boolean;
  widgetStyle?: boolean;
  onFileDownload?: (fileUrl: string, fileId?: string, fileName?: string) => void;
};

export const FilePreviews: React.SFC<Props> = ({
  attachments,
  alignRight,
  widgetStyle,
  onFileDownload
}) => (
  <div
    className={classNames(
      styles["thumbnail-grid"],
      { [styles["align-right"]]: alignRight },
      (widgetStyle && styles.widget) || styles.dashboard
    )}
  >
    {attachments.map((attachment) => (
      <div key={attachment.id || attachment.token} className={styles.thumbnail}>
        <FileThumbnail
          attachment={attachment}
          widgetStyle={widgetStyle}
          onFileDownload={onFileDownload}
        />
      </div>
    ))}
  </div>
);
